(function () {
  let userAgent = navigator.userAgent;

  Sparkle.Browser = {
    MobileSafari: {
      alwaysShowNavBar,
      removeAlwaysShowNavBar,
    },
  };

  // HELPER FUNCTIONS

  // MOBILE SAFARI / IPHONE
  function alwaysShowNavBar() {
    // Only target user agents that are likely Mobile Safari
    // Catch for ie 11
    if ([].includes) {
      if (userAgent.includes("iPhone") && userAgent.includes("Safari")) {
        iPhoneStyleOverride();
      }
    }
  }

  function iPhoneStyleOverride() {
    jQuery("html").addClass("mobile-safari-show-navbar");
    jQuery("body").addClass("mobile-safari-show-navbar-scroll");
  }

  function removeAlwaysShowNavBar() {
    jQuery("html").remove("mobile-safari-show-navbar");
    jQuery("body").removeClass("mobile-safari-show-navbar-scroll");
  }
})();
